export function IntlGlobalProvider({children}: any) {
  return children;
}
